/**
 * The activity timeline's catalog-tag filter, and the one way it can be
 * legitimately refused (GDN-2776).
 *
 * `recent-activity?tag=<name>` resolves the tag to an event-type list at query
 * time. A tag the environment's catalog has never heard of is a 400
 * `unknown_activity_tag`, not a server fault: staging and dev catalogs are
 * curated separately from production, so a tag that exists in one may simply
 * not have been curated in another. Callers need to tell that apart from a real
 * failure, because the honest response is "this filter isn't available here",
 * not "the activity store is down".
 */
import { matchesApiError } from './api-error';

/**
 * The catalog tag for jotbill's revenue-cycle lifecycle.
 *
 * Verified against the production catalog on 2026-08-08: 44 member event types.
 * Deliberately NOT `subscription`, which tags SaaS subscription billing — a
 * different population that happens to share the word "billing".
 */
export const BILLING_EVENT_TAG = 'billing';

/**
 * True when the activity store refused a tag filter because no such tag exists
 * in this environment's event catalog.
 */
export const isUnknownActivityTag = (error: unknown): boolean =>
  matchesApiError(error, { status: 400, errorCode: 'unknown_activity_tag' });
